var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctm-notfound"},[_c('div',[_c('img',{staticClass:"img-responsive",attrs:{"src":require("@/assets/LogoBG.png"),"alt":_vm.$t('comingsoon.dentistry')}}),_c('h1',[_vm._v(_vm._s(_vm.$t('notfoundpage.header')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }